import base from "../../baseurl";
import token from "../../getTk";

const Create = async (
  documentTypeId,
  url,
  disciplineId,
  sportEventDocumentId
) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("sport-documents/update", {
      json: { documentTypeId, url, disciplineId, sportEventDocumentId },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
